import ComponentBase from "@components/ComponentBase";
import { ComponentElem } from "@components/interfaces";
import { Emitter } from "strict-event-emitter";
import { Product } from "./ProductTypes";

export default class PlanTimeSelect extends ComponentBase
{
  // selectedId: string;
  // selectedTime: string;

  emitter: Emitter<{change: [timeData: Product.TimeData]}>

  $optionDic: {[key: string]: JQuery}

  constructor(elem: ComponentElem, dataList: Product.TimeData[])
  {
    super(elem);
    this.emitter = new Emitter();
    this.applyData(dataList);
  }

  applyData(dataList: Product.TimeData[])
  {
    this.$optionDic = {};

    this.$root.empty();
    dataList.forEach((data: Product.TimeData) =>
    {
      let $option = $(`<div class="option" data-time-id="${data.id}">${data.time}</div>`);
      this.$root.append($option);

      this.$optionDic[data.id] = $option;

      $option.on("click", (event: JQuery.Event) =>
      {
        event.preventDefault();

        this.$root.find(".option").attr("is-selected", "false");
        $option.attr("is-selected", "true");
        // this.selectedId = data.id;
        // this.selectedTime = data.time;
        this.emitter.emit("change", data);
      });
    });
  }

  selectTime(timeId: string)
  {
    let $option = this.$optionDic[timeId];
    if($option)
    {
      $option.click();
    }
    else
    {
      throw new Error();
    }
  }

  reset()
  {
    for(let key in this.$optionDic)
    {
      let $option: JQuery = this.$optionDic[key];
      $option.attr("is-selected", "false");
    }
    
  }
}